import {  Tabs, Badge } from 'antd'
import React, { useState } from 'react'
import CostListAdd from './CostListAdd'             
import Main from '../../cpn/Main';
import { PlusOutlined, ClockCircleOutlined, ScheduleOutlined, AuditOutlined, FileDoneOutlined, FileSearchOutlined } from '@ant-design/icons';
import CostListPendding from './CostListPendding';
import CostListSubmitted from './CostListSubmitted';            
import CostListNeedApprove from './CostListNeedApprove';
import CostListApproved from './CostListApproved';
import CostListNeedRead from './CostListNeedRead';
import CostListAll from './CostListAll';
function CostList(props) {
    const qy_id = props.qy_id;
    const qy_name = props.qy_name;
    const yh_id = props.yh_id;
    const yh_name = props.yh_name;
    const yh_qx = props.yh_qx || '';  
    const [list,setList] = React.useState(props.ddzcList || []);
    React.useEffect(() => {
        if (props.ddzcList && props.ddzcList.length > 0) {            
            const formattedData = props.ddzcList.map((item,index) => ({
                key: item.ddzc_id,
                ddzc_content: item.ddzc_content,
                ddzc_ctime: item.ddzc_ctime,
                ddzc_price: item.ddzc_price,
                ddzc_uname: item.ddzc_uname,
                ddzc_num: item.ddzc_num,                  
                ddzc_uid: item.ddzc_uid,   
                ddzc_type_name: item.ddzc_type_name,               
                ddzc_kh_name: item.ddzc_kh_name,               
                ddzc_amount: item.ddzc_amount,               
                ddzc_bzd_danhao:item.ddzc_bzd_danhao,
                ddzc_bzd_id:item.ddzc_bzd_id,
                ddzc_date:item.ddzc_date,
                ddzc_date_end:item.ddzc_date_end,
                ddzc_bzd_name:item.ddzc_bzd_name,
                ddzc_type_id:item.ddzc_type_id,
                ddzc_kh_id:item.ddzc_kh_id,
                ddzc_state:item.ddzc_state,
                ddzc_bm_id:item.ddzc_bm_id,
                ddzc_bm_name:item.ddzc_bm_name,
                ddzc_khyhzh_id:item.ddzc_khyhzh_id,
                ddzc_khyhzh_name:item.ddzc_khyhzh_name,
                ddzc_image_name:item.ddzc_image_name,
                ddzc_image_file:item.ddzc_image_file,
                ddzc_state_time:item.ddzc_state_time,
            }));
            const sortedData = formattedData.sort((a, b) => new Date(a.dsbzdsz_ctime) - new Date(b.dsbzdsz_ctime));
            setList(sortedData);
            
        }else{
            setList([])
        }}, [props.ddzcList])
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_cost_active_key') || '1');
    return (
        <Main 
            selectedKeys={['/CostList']}
            qy_id={props.qy_id}
            qy_name={props.qy_name}
            yh_id={props.yh_id}
            yh_name={props.yh_name}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            reportEndNeedReadNum={props.reportEndNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
            yh_qx={props.yh_qx}
        >                            
            <Tabs
                activeKey={activeKey} 
                onChange={(key) => {    
                    setActiveKey(key)
                    localStorage.setItem('jtg-caiwu_cost_active_key', key)
                }}
                items={[
                    {
                        key: '0',
                        label: '新增',
                        children: <CostListAdd qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <PlusOutlined />,
                    },
                    {
                        key: '1',
                        label: '我未提交的',
                        children: <CostListPendding qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <ClockCircleOutlined />,
                    },
                    {
                        key: '2',
                        label: <span>我已提交的<Badge count={Number(props.ddzcRejectedNum) + Number(props.ddzcEndNeedReadNum)}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <CostListSubmitted qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} ddzcRejectedNum={props.ddzcRejectedNum} ddzcEndNeedReadNum={props.ddzcEndNeedReadNum} yh_qx={yh_qx}/>,
                        icon: <ScheduleOutlined />,
                    },
                    {
                        key: '3',
                        label: <span>需要我审批的<Badge count={props.ddzcNeedApproveNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <CostListNeedApprove qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.ddzcSpList} yh_qx={yh_qx}/>,
                        icon: <AuditOutlined />,
                    },
                    {
                        key: '4',
                        label: '我已审批的',
                        children: <CostListApproved qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.ddzcSpList} yh_qx={yh_qx}/>,
                        icon: <FileDoneOutlined />,
                    },
                    {
                        key: '5',
                        label: <span>抄送给我的<Badge count={props.ddzcNeedReadNum}> <span style={{marginLeft:'10px',color:'#fff'}}> 1</span></Badge></span>,
                        children: <CostListNeedRead qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={props.ddzcSpList} yh_qx={yh_qx}/>,
                        icon: <FileDoneOutlined />,
                    },
                    ...(yh_qx.includes('管理') ? [{
                        key: '6',
                        label: '全部单据',
                        children: <CostListAll qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} list={list} yh_qx={yh_qx}/>,
                        icon: <FileSearchOutlined />,
                    }] : []),
                ]}
            />
        </Main>
    )
}

export default CostList